<template>
  <div>
    <v-toolbar flat color="white" class="mb-4">
      <v-toolbar-title>{{ $t("routes.add_supporter") }}</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
    </v-toolbar>

    <supporter-form></supporter-form>
  </div>
</template>

<script>
import SupporterForm from "./components/SupportersForm";
export default {
  name: "AddSupporter",
  components: {
    SupporterForm
  }
};
</script>

<style lang="scss" scoped></style>
